
// import React from "react";
import Header from "./header";
import ServicesFooter from "../services/footer";
import "../../index.css";
import { Outlet } from "react-router-dom";

export default function ServicesLayout() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow"><Outlet /></main>
      <ServicesFooter />
    </div>
  );
}
